import { Outlet } from 'react-router-dom';

import { ROUTES } from '../../../constants/routes';

import StaffLoginPage from 'pages/login/staff/login';
import WithNotAuth from 'shared/components/hocs/with-not-auth';

export const STAFF_LOGIN_ROUTE = {
  path: '',
  element: (
    <WithNotAuth>
      <Outlet />
    </WithNotAuth>
  ),
  children: [
    {
      path: ROUTES.LOGIN.path,
      element: <StaffLoginPage />,
    },
  ],
};
